// extracted by mini-css-extract-plugin
module.exports =  {"base-badge":"k7n817N","baseBadge":"k7n817N","content":"AXHdb6x"};